import { createFileRoute } from "@tanstack/react-router";

import { LanguageSelect } from "~/components/language-select";
import { DiscoveryStep } from "~/components/ui/discovery-step";
import { FormField } from "~/components/ui/form-field";
import { useDiscoveryForm } from "~/lib/hooks/use-discovery-form";
import {
  PreferredLanguageSchema,
  preferredLanguagesStep,
} from "~/lib/schemas/coach-discovery";
import { createNoIndexMeta } from "~/lib/shared/meta";

export const Route = createFileRoute("/_public/discovery/steps/9/")({
  head: () =>
    createNoIndexMeta(
      "Step 9: Language Preferences – Dream Coach Match",
      "Set your preferred coaching languages in our discovery process",
    ),
  component: Step9Component,
});

function Step9Component() {
  const { form, handleNextStep, handlePreviousStep } = useDiscoveryForm({
    step: 9,
    schema: PreferredLanguageSchema,
  });
  const { register, handleSubmit, formState, watch } = form;
  const { errors, isSubmitting, isValid } = formState;

  const watchedLanguages = watch("preferredLanguages") || [];
  const tooManyLanguages = watchedLanguages.length > 3;

  const onSubmit = (_data: { preferredLanguages?: string[] }) => {
    handleNextStep();
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <DiscoveryStep.Title title={preferredLanguagesStep.title} />
      <DiscoveryStep.Card>
        <FormField error={errors.preferredLanguages?.message}>
          <LanguageSelect
            field={{
              name: "preferredLanguages",
              value: watchedLanguages,
            }}
            props={register("preferredLanguages")}
          />
          {tooManyLanguages && (
            <p className="mt-2 text-sm text-red-600">
              You can select up to 3 languages only.
            </p>
          )}
        </FormField>
      </DiscoveryStep.Card>
      <DiscoveryStep.Control
        prev={handlePreviousStep}
        type="submit"
        disabled={!isValid}
        loading={isSubmitting}
      />
    </form>
  );
}
